// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ps-0";